(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bed-inspiration-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bed-inspiration').forEach((root) => {
  if (root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const toggle = root.querySelector('.bed-inspiration__toggle');
  const dialog = root.querySelector('[data-gallery-dialog]');
  const dialogImage = root.querySelector('[data-gallery-dialog-image]');
  const close = root.querySelector('[data-gallery-close]');

  toggle?.addEventListener('click', () => {
    const expanded = root.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Vis færre bilder' : 'Vis flere';
  });

  root.querySelectorAll('[data-gallery-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!dialog || !dialogImage) return;
      dialogImage.src = button.dataset.image || '';
      dialogImage.alt = button.querySelector('img')?.alt || '';
      dialog.showModal();
    });
  });

  close?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
});

  } catch(e) { console.error(e); }
})();
})();
